// One entry per exam paper. PapersPage lists a level's papers at /<level>/papers; the PDFs are
// public/pdf/<level>/<level>-<slug>-<chi|eng>.pdf (built outside the repo, exported with Google Docs).
// scripts/gen-pages.js keeps its own title and description for each level's papers page.

const papers = [
{
  level: "s3", slug: "first-term-paper-1",
  zh: "中三數學上學期試卷（一）", en: "S3 Mathematics First Term Paper 1",
  chapters: "Ch 1–6：因式分解、指數定律、百分數、一元一次不等式、集中趨勢的量度、演繹幾何",
  info: "甲部（一）、甲部（二）、乙部共 17 題 · 1 小時 30 分鐘 · 全卷 100 分",
},
];

export default papers;
